// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"24":"5bed0d7a","115":"af492e69","208":"1d83fb36","215":"9642a0e5","219":"ac8aaeb2","646":"36935e97","811":"fce5ad39","851":"3c555094"}[chunkId] + ".chunk.js";
};